import { TenderOfferParticipant } from 'types';
import { tenderParticipantStatusTypes } from 'utils/tenderOfferTypes';

type GetSaleDate = {
  participant?: TenderOfferParticipant;
};

export const getSaleDate = ({ participant }: GetSaleDate): Date | null => {
  if (!participant) return null;

  if (participant.status === tenderParticipantStatusTypes.ACCEPTED.value) {
    return participant.operationDate
      ? new Date(participant.operationDate)
      : null;
  }

  return null;
};
